<img [src]="'/assets/flags/3x2/' + countryCode.toUpperCase() + '.svg'" [class]="cssClass" height="16" width="24" loading="lazy" [alt]="countryCode">
